/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInChatResponseManualClassification = typeof LinkedInChatResponseManualClassification[keyof typeof LinkedInChatResponseManualClassification] | null;


export const LinkedInChatResponseManualClassification = {
  interested: 'interested',
  not_interested: 'not_interested',
  out_of_office: 'out_of_office',
} as const;
